import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Circles from './pages/Circles';
import CircleDetail from './pages/CircleDetail';
import MoodTracker from './pages/MoodTracker';
import Journal from './pages/Journal';
import Discovery from './pages/Discovery';
import PublicJournals from './pages/PublicJournals';
// import ProtectedRoute from './components/ProtectedRoute';
import Profile from './pages/Profile';
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/dashboard"
            element={
              // <ProtectedRoute>
                <Dashboard />
              // </ProtectedRoute>
            }
          />
          <Route 
  path="/profile" 
  element={
    // <ProtectedRoute>
      <Profile />
    // </ProtectedRoute>
  } 
/>
          <Route
            path="/circles"
            element={
              // <ProtectedRoute>
                <Circles />
              // </ProtectedRoute>
            }
          />
          <Route 
  path="/discovery" 
  element={
    // <ProtectedRoute>
      <Discovery />
    // </ProtectedRoute>
  } 
/>
<Route path="/community" element={<PublicJournals />} />

          <Route
            path="/circles/:id"
            element={
              // <ProtectedRoute>
                <CircleDetail />
              // </ProtectedRoute>
            }
          />
          <Route
            path="/mood"
            element={
              // <ProtectedRoute>
                <MoodTracker />
              // </ProtectedRoute>
            }
          />
          <Route 
  path="/journal" 
  element={
    // <ProtectedRoute>
      <Journal />
    // </ProtectedRoute>
  } 
/>
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    
  );
}

export default App;
